import React from 'react';
import { Container, Typography, Box, Grid, Card, CardContent } from '@mui/material';
import VerifiedIcon from '@mui/icons-material/Verified';

const Certifications = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      <Box sx={{ mb: 6, textAlign: 'center' }}>
        <Typography variant="h3" sx={{ mb: 2, fontWeight: 'bold' }}>
          Our Certifications
        </Typography>
        <Typography variant="h6" sx={{ color: '#666', mb: 4 }}>
          Accredited by leading national and international bodies
        </Typography>
      </Box>

      {/* Main Certifications */}
      <Grid container spacing={4} sx={{ mb: 8 }}>
        <Grid item xs={12} md={6}>
  <Card sx={{ height: "100%", backgroundColor: "#fff8e1" }}>
    <CardContent>

      <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
        <VerifiedIcon
          sx={{
            fontSize: "3rem",
            color: "#f57c00",
            mr: 2
          }}
        />

        <Typography
          variant="h5"
          sx={{ fontWeight: "bold" }}
        >
          Corporate Identity & Legal Registration
        </Typography>
      </Box>

      <Typography variant="body1" paragraph>
        Kavya Institute operates under
        <strong> KAVYARG GLOBAL INDIA PRIVATE LIMITED</strong>,
        a Government of India registered corporate entity.
      </Typography>

      <Typography
        variant="body2"
        sx={{ color: "#666" }}
      >
        Registration Details:
      </Typography>

      <Typography
        component="div"
        variant="body2"
        sx={{ ml: 2, mt: 1 }}
      >
        ✓ CIN Number:
        <strong> U85499DC2026PTC471131</strong>
        <br />

        ✓ Corporate Registration No.:
        <strong> UDYAM-BR-35-0003536</strong>
        <br />

        ✓ Private Limited Company
        <br />

        ✓ Government of India Registered
        <br />

        ✓ Regulatory & Statutory Compliance
      </Typography>

      <Typography
        variant="body2"
        sx={{
          mt: 3,
          fontStyle: "italic",
          color: "#555"
        }}
      >
        A Unit of KAVYARG GLOBAL INDIA PRIVATE LIMITED
      </Typography>

    </CardContent>
  </Card>
</Grid>
        <Grid item xs={12} md={6}>
          <Card sx={{ height: '100%', backgroundColor: '#e3f2fd' }}>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <VerifiedIcon sx={{ fontSize: '3rem', color: '#1976d2', mr: 2 }} />
                <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
                  ISO 9001:2015 Certified
                </Typography>
              </Box>
              <Typography variant="body1" paragraph>
                Kavya Institute is certified by the International Organization for Standardization (ISO),
                ensuring our commitment to quality management and continuous improvement.
              </Typography>
              <Typography variant="body2" sx={{ color: '#666' }}>
                This certification demonstrates our adherence to international standards in:
              </Typography>
              <Typography component="div" variant="body2" sx={{ ml: 2, mt: 1 }}>
                ✓ Quality Management Systems<br />
                ✓ Process Documentation<br />
                ✓ Student Satisfaction<br />
                ✓ Continuous Improvement<br />
                ✓ Risk Management
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card sx={{ height: '100%', backgroundColor: '#f3e5f5' }}>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <VerifiedIcon sx={{ fontSize: '3rem', color: '#7b1fa2', mr: 2 }} />
                <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
                  UDYAM Registered
                </Typography>
              </Box>
              <Typography variant="body1" paragraph>
                Registered under the UDYAM portal (Ministry of MSME, Government of India), recognizing
                us as a legitimate and formally recognized educational enterprise.
              </Typography>
              <Typography variant="body2" sx={{ color: '#666' }}>
                UDYAM registration provides:
              </Typography>
              <Typography component="div" variant="body2" sx={{ ml: 2, mt: 1 }}>
                ✓ Government Recognition<br />
                ✓ Access to Government Schemes<br />
                ✓ Business Support Services<br />
                ✓ Compliance with Ministry Standards<br />
                ✓ Eligibility for Subsidies & Credits
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        {/* NEW GRID CARD */}
        <Grid item xs={12} md={6}>
          <Card sx={{ height: '100%', backgroundColor: '#e8f5e9' }}>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <VerifiedIcon sx={{ fontSize: '3rem', color: '#2e7d32', mr: 2 }} />
                <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
                  Government of India Registered
                </Typography>
              </Box>

              <Typography variant="body1" paragraph>
                Kavya Institute is officially registered under the Government of India as a recognized
                corporate entity, ensuring compliance with national business and regulatory standards.
              </Typography>

              <Typography variant="body2" sx={{ color: '#666' }}>
                Registration Details:
              </Typography>

              <Typography component="div" variant="body2" sx={{ ml: 2, mt: 1 }}>
                ✓ Government of India Registration<br />
                ✓ Corporate Registration No.: <strong>UDYAM-BR-35-0003536</strong><br />
                ✓ Recognized Business Entity<br />
                ✓ Regulatory Compliance
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        

      </Grid>

      {/* Additional Recognitions */}
      <Box sx={{ mb: 8 }}>
        <Typography variant="h4" sx={{ mb: 4, fontWeight: 'bold', textAlign: 'center' }}>
          Additional Recognitions
        </Typography>
        <Grid container spacing={3}>
          {[
            {
              title: 'Ministry of Education Approval',
              content: 'Our courses are aligned with guidelines and standards set by the Ministry of Education.',
            },
            {
              title: 'Industry Partnership',
              content: 'Partnerships with leading IT companies, software firms, and educational tech providers.',
            },
            {
              title: 'Best Educational Institute Award 2023',
              content: 'Recognized by Indian Institute of Professionals for excellence in education delivery.',
            },
            {
              title: 'Customer Satisfaction Rating: 4.8/5',
              content: 'Consistently rated highly by students and parents for quality and service.',
            },
          ].map((cert, index) => (
            <Grid item xs={12} sm={6} key={index}>
              <Card sx={{ p: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                  <VerifiedIcon sx={{ color: '#4caf50', mr: 2, mt: 0.5 }} />
                  <Box>
                    <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
                      {cert.title}
                    </Typography>
                    <Typography variant="body2">{cert.content}</Typography>
                  </Box>
                </Box>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* Compliance & Standards */}
      {/* Compliance & Standards */}
      <Box sx={{ backgroundColor: '#f5f5f5', p: 4, borderRadius: 2, mb: 8 }}>
        <Typography variant="h4" sx={{ mb: 3, fontWeight: 'bold' }}>
          Compliance & Training Standards
        </Typography>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" sx={{ mb: 1, fontWeight: 'bold', color: '#1976d2' }}>
              Industrial Safety Standards
            </Typography>
            <Typography variant="body2">
              Training aligned with national and international industrial safety guidelines and best practices.
            </Typography>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" sx={{ mb: 1, fontWeight: 'bold', color: '#1976d2' }}>
              Practical Fire Safety Training
            </Typography>
            <Typography variant="body2">
              Hands-on fire safety drills, hazard control exercises, and emergency response simulations.
            </Typography>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" sx={{ mb: 1, fontWeight: 'bold', color: '#1976d2' }}>
              Health & Environment Awareness
            </Typography>
            <Typography variant="body2">
              Programs cover occupational health, workplace hazard prevention, and environmental safety compliance.
            </Typography>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" sx={{ mb: 1, fontWeight: 'bold', color: '#1976d2' }}>
              Government Recognized Curriculum
            </Typography>
            <Typography variant="body2">
              Courses designed as per recognized industrial safety frameworks and government-aligned guidelines.
            </Typography>
          </Grid>
        </Grid>
      </Box>


      {/* Student Success Stories */}
      {/* Student Success Stories */}
      <Box>
        <Typography variant="h4" sx={{ mb: 3, fontWeight: 'bold', textAlign: 'center' }}>
          What Our Students Say
        </Typography>

        <Grid container spacing={3}>
          {[
            {
              name: 'Ravi Kumar',
              course: 'Diploma in Fire & Industrial Safety',
              feedback:
                'The practical fire fighting training and safety drills gave me real confidence to work on industrial sites. Trainers are very supportive and experienced.',
            },
            {
              name: 'Neha Singh',
              course: 'Advance Diploma in Industrial Safety Management',
              feedback:
                'Best institute for safety courses. We had real equipment training and site safety case studies which helped me get a job in a manufacturing company.',
            },
            {
              name: 'Imran Ali',
              course: 'Construction Safety Course',
              feedback:
                'Excellent teaching with focus on real workplace hazards. I now understand how to handle safety inspections and emergency situations properly.',
            },
            {
              name: 'Pooja Sharma',
              course: 'Fire Safety Officer Training',
              feedback:
                'Hands-on fire extinguisher training and evacuation drills were very useful. This course helped me start my career as a safety officer.',
            },
            {
              name: 'Sandeep Yadav',
              course: 'Industrial Health & Safety',
              feedback:
                'The institute focuses a lot on practical learning and real industrial scenarios. I got placed in a safety department after completing my course.',
            },
            {
              name: 'Aarti Verma',
              course: 'Environmental Health & Safety',
              feedback:
                'Very good learning environment and experienced faculty. The course helped me understand workplace risk assessment and safety compliance.',
            },
          ].map((student, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card sx={{ backgroundColor: '#f0f4ff', height: '100%' }}>
                <CardContent>
                  <Typography variant="body1" paragraph>
                    "{student.feedback}"
                  </Typography>

                  <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                    {student.name}
                  </Typography>

                  <Typography variant="body2" sx={{ color: '#1976d2' }}>
                    {student.course}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>

    </Container>
  );
};

export default Certifications;
